import { getSpecValue } from "./productSpecs";
import { parseNumericValue } from "./compareFieldUtils";

const TRADEOFF_SPEC_KEYS = [
  { key: "ram", label: "RAM" },
  { key: "storage", label: "Storage" },
  { key: "battery", label: "Battery" },
  { key: "resolution", label: "Resolution" },
  { key: "weight", label: "Weight" },
  { key: "print_speed", label: "Print speed" },
  { key: "connectivity", label: "Connectivity" },
];

export const buildMatchTradeOff = (product, topPick) => {
  if (!product || !topPick || product._id === topPick._id) return null;

  const parts = [];
  const productPrice = Number(product.price);
  const topPrice = Number(topPick.price);

  if (
    Number.isFinite(productPrice) &&
    Number.isFinite(topPrice) &&
    productPrice !== topPrice
  ) {
    const diff = productPrice - topPrice;
    if (diff < 0) {
      parts.push(`$${Math.abs(diff).toLocaleString()} less than #1`);
    } else {
      parts.push(`$${diff.toLocaleString()} more than #1`);
    }
  }

  for (const { key, label } of TRADEOFF_SPEC_KEYS) {
    const value = getSpecValue(product, key);
    const topValue = getSpecValue(topPick, key);
    if (!value || !topValue || String(value) === String(topValue)) continue;

    const numericA = parseNumericValue(value);
    const numericB = parseNumericValue(topValue);
    if (numericA != null && numericB != null) {
      if (numericA > numericB) {
        parts.push(`More ${label.toLowerCase()} (${value})`);
      } else {
        parts.push(`Less ${label.toLowerCase()} (${value})`);
      }
    } else {
      parts.push(`${label}: ${value}`);
    }
    break;
  }

  return parts.length ? parts.join(" · ") : null;
};

export const buildMatchPriceSummary = (products) => {
  const prices = products
    .map((p) => Number(p?.price))
    .filter((p) => Number.isFinite(p));
  if (prices.length < 2) return null;

  const min = Math.min(...prices);
  const max = Math.max(...prices);
  if (min === max) return `All options priced at $${min.toLocaleString()}`;
  return `Price range: $${min.toLocaleString()} – $${max.toLocaleString()}`;
};
